import React from "react";
import TimelineComponent from "../../component/roadmap/timeline";
import Roadmap from "../../component/roadmap/index";
export function Timeline() {
  return <Roadmap />;
}
